export const isMobileOrTablet = (): boolean => {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;

  // UA-based detection
  if (/android|iphone|ipod|windows phone/i.test(ua)) return true;

  // iPad detection (even in desktop mode Safari)
  if (/ipad/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    return true;
  }

  return false;
};
